import { AutogenModelOtherChargeBill, AutogenRowOtherChargeBill } from "./autogen/AutogenModelOtherChargeBill";

export class ModelOtherChargeBill extends AutogenModelOtherChargeBill<RowOtherChargeBill> {
	constructor() {
		super(RowOtherChargeBill);
	}
}

export class RowOtherChargeBill extends AutogenRowOtherChargeBill {
}